import React from 'react'
import css3 from "../assets/logos/images/css3_logo.png"
import html5 from "../assets/logos/images/html_logo.png"
import javascript from "../assets/logos/images/js_logo.png"
import tailwind from "../assets/logos/images/tailwind_logo.png"
import react from "../assets/logos/images/react_logo.png"
import swift from "../assets/logos/images/swift_logo_original.png"
import python from "../assets/logos/images/python_logo.png"
import matlab from "../assets/logos/images/matlab_logo.png"
import git from "../assets/logos/images/git_logo.png"
import azure from "../assets/logos/images/azure_devops_logo.png"
import solidworks from "../assets/logos/images/solidworks_logo.png"
import catia from "../assets/logos/images/catia_logo.png"
import tdx from "../assets/logos/images/3DX_logo.png"
import ansys from "../assets/logos/images/ANSYS_logo.png"
// import { DiPython, DiReact, DiSwift, DiCss3, DiHtml5, DiJavascript1, DiLinux, DiGit, } from "react-icons/di";
// import { SiAnsys } from "react-icons/si";
// import { SiAzuredevops } from "react-icons/si";

const Skills = () => {
  var logos = [
    css3, html5, javascript, tailwind, react, swift, python, matlab, git, azure, solidworks, catia, tdx, ansys
  ];

  return (
    <div className='page-startup'>
      <div className='h-full flex flex-col justify-evenly pb-10'>

        <div className='flex justify-center title text-4xl'>Skills</div>

          <div className='px-10 text-center align-middle text-[40px] text-gray-300 lg:text-[60px] md:text-[75px]'>
            {logos.map((l, i) => {
              return <div key={i} className='inline-block px-[10px] align-middle'> <img src={l} alt="skill_logo" className='h-[40px] rounded-lg lg:h-[55px] md:h-[70px]' /> </div>
            })}
          </div>

      </div>

    </div>

  )
}

export default Skills